import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type ShortcutConnectorConfig = typeof ShortcutConnector._.Config;

export const ShortcutConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Shortcut,
  logoPath: 'images/shortcut-logo.svg',
  categories: [IntegrationConnectorCategory.DevOps],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ApiToken,
      configSchema: z.object({}),
      encryptedConfigSchema: z.object({
        apiToken: z.string().trim().startsWith('sct_r_'),
      }),
    }),
  ]),
});
